import { render, staticRenderFns } from "./adfox-banner.vue?vue&type=template&id=6658c3d8"
import script from "./adfox-banner.vue?vue&type=script&lang=ts"
export * from "./adfox-banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports